import { Controller } from '@hotwired/stimulus'

const TOOLTIP_WIDTH = 112
const TOOLTIP_HEIGHT = 38
const TOOLTIP_OFFSET = 12

export default class extends Controller {
  static targets = ['svg', 'hover', 'crosshair', 'dot', 'tooltip', 'tooltipDate', 'tooltipValue']
  static values = { points: Array }

  track(event) {
    const point = this.closestPoint(this.pointerX(event))
    if (!point) return

    this.crosshairTarget.setAttribute('x1', point.x)
    this.crosshairTarget.setAttribute('x2', point.x)
    this.dotTarget.setAttribute('cx', point.x)
    this.dotTarget.setAttribute('cy', point.y)
    this.tooltipDateTarget.textContent = point.label
    this.tooltipValueTarget.textContent = point.value
    this.tooltipTarget.setAttribute('transform', this.tooltipTransform(point))
    this.hoverTarget.classList.remove('hidden')
  }

  hide() {
    this.hoverTarget.classList.add('hidden')
  }

  pointerX(event) {
    const bounds = this.svgTarget.getBoundingClientRect()
    const viewBoxWidth = this.svgTarget.viewBox.baseVal.width

    return ((event.clientX - bounds.left) / bounds.width) * viewBoxWidth
  }

  closestPoint(x) {
    return this.pointsValue.reduce((closest, point) => {
      if (!closest) return point

      return Math.abs(point.x - x) < Math.abs(closest.x - x) ? point : closest
    }, null)
  }

  tooltipTransform(point) {
    const viewBoxWidth = this.svgTarget.viewBox.baseVal.width
    const overflowsRight = point.x + TOOLTIP_OFFSET + TOOLTIP_WIDTH > viewBoxWidth
    const x = overflowsRight ? point.x - TOOLTIP_OFFSET - TOOLTIP_WIDTH : point.x + TOOLTIP_OFFSET
    const y = Math.max(0, point.y - TOOLTIP_HEIGHT / 2)

    return `translate(${x}, ${y})`
  }
}
